<!-- 选座 -->
<template>
  <div>
    <van-nav-bar
        title="选座"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div id="container">
      <div class="seats-option">
        <ul>
          <li>
            <img src="@/assets/images/optional.png"/>
            <span>可选</span>
          </li>
          <li>
            <img src="@/assets/images/sold.png"/>
            <span>已售</span>
          </li>
          <li>
            <img src="@/assets/images/best.png"/>
            <span>最佳观影位</span>
          </li>
        </ul>
      </div>
      <div id="screen" ref="maxScreen">
        <img src="@/assets/images/screen.png" alt="">
        <p>{{show_info.hall_name || ''}}</p>
      </div>
      <div class="siled" ref="sequence" id="sequence"></div>
      <canvas ref="maxCanvas" id="canvas"></canvas>
    </div>
    <div class="footer-container" ref="footer">
              <div class="notice"> {{show_info.notice || ''}} </div>
      <div class="film-info">
        <p class="name">{{show_info.film_name || ''}}</p>
        <p class="time">{{show_info.show_time || ''}} {{show_info.show_version_type||''}}</p>
      </div>
      <!--        <div class="rec-node" v-if="showRec">-->
      <!--            <span>推荐座位</span>-->
      <!--            <ul>-->
      <!--                <li @click="recSeat(1)">1人</li>-->
      <!--                <li @click="recSeat(2)">2人</li>-->
      <!--                <li @click="recSeat(3)">3人</li>-->
      <!--            </ul>-->
      <!--        </div>-->
      <div class="selected-node" v-if="showSeats">
        <ul>
          <li v-for="(item, index) in selectedSeatsData" :key="index">
            <div>
              <!--                        <p class="seat-name">{{ item.y }}排{{ item.x }}列</p>-->
              <p class="seat-name">{{ item.seatNo }}</p>
              <p class="seat-price">到手价 {{item.price || 0}}</p>
            </div>
            <span @click="removeSeat(index)">x</span>
          </li>
        </ul>
      </div>
      <div class="btn" :style="showSeats ? '' : 'margin-top: 15px'" v-if="!selectedSeatsData.length">请先选座</div>
      <div class="btn" :style="showSeats ? '' : 'margin-top: 15px'" v-else @click="confirmSeats">确认选座</div>
    </div>
  </div>
</template>

<script>
const seatData = require('./json/seats.json')
import {getSeatList, lockSeat} from '@/api/cinema'
export default {
  name: "seat",
  components: {},
  props: {},
  data() {
    return {
      // 是否显示推荐区域
      showRec: true,
      // 是否显示座位图
      showSeats: false,
      // 座位图对象
      seatsMap: null,
      // 元素对象
      el: {
        // 最大画布对象
        maxCanvas: null,
        // 最大屏幕对象
        maxScreen: null,
        // 序列对象
        sequence: null
      },
      // 警告选项
      alert_option: {
        // 警告文本
        alert_text: '非常棒最佳观影区位置~',
        // 图片路径
        img_src: require('@/assets/images/good_bg.png'),
        // 背景颜色
        bg_color: '#ff9800',
        // 文本颜色
        text_color: '#fff',
        // 字体大小
        fontSize: '12px',
        // 是否显示警告
        is_show_alert: true
      },
      // 座位选项
      seatsOptions: {
        // 图片选项
        image_option: {
          // 爱心图标尺寸
          love: {
            w: 152,
            h: 64
          },
          // 普通图标尺寸
          normal: {
            w: 68,
            h: 64
          }
        },
        // 线条颜色
        line: {
          // 最佳线路颜色
          best_color: '#F00',
          // 中心线颜色
          center_color: '#c8c8c8'
        },
        // 空白间隔
        blank: {
          // 左侧间隔
          left: 10,
          // 右侧间隔
          right: 10,
          // 上方间隔
          top: 20
        },
        // 最大可选座数量
        maxSelectNum: 4,
        // 选择座位回调函数
        selectSeatCall: this.selectCall
      },
      // 背景图片路径
      background: {
        // 未设置背景
        un_set: require('@/assets/images/optional.png'),
        // 未收藏背景
        un_love: require('@/assets/images/un_love.png'),
        // 设置背景
        set: require('@/assets/images/set.png'),
        // 已售出的爱心座位背景
        sold_love: require('@/assets/images/sold_love.png'),
        // 爱心座位背景
        love: require('@/assets/images/love.png'),
        // 已售出座位背景
        sold: require('@/assets/images/sold.png'),
        // 单个座位背景
        mend: require('@/assets/images/wei_sigle.png'),
        // 爱心单个座位背景
        love_mend: require('@/assets/images/wei_love.png')
      },
      // 页脚高度
      footerHeight: 231,
      // 已选座位数据
      selectedSeatsData: [],
      // 参数对象
      params: {
        // 透传参数
        param:'',
        // 显示编号
        showid:'',
        // 电话号码
        mobile:''
      },
      // 影片信息
      film_info:{},
      // 显示信息
      show_info:{
        // 影片名称
        film_name:'',
        // 录入时间
        show_time: '',
        // 显示版本类型
        show_version_type: ''
      },
      // 座位数据
      seats: seatData
    }
  },
  methods: {
    // 初始化地图函数
    initMap() {
      // 创建Seats对象
      this.seatsMap = new Seats(this.el.maxCanvas, {
        maxMap: this.seatsOptions,
        alert_option: this.alert_option
      })
      // 设置地图背景
      this.seatsMap.setBackground(this.background)
      // 获取座位数据
      this.getSeatsData()
    },
    // 处理座位选择
    recSeat(num) {
      // 调用seatsMap的recSeatHandler方法
      this.seatsMap.recSeatHandler(num)
    },
    // 删除座位
    removeSeat(index) {
      // 获取要删除的座位数据
      let data = this.selectedSeatsData[index]
      // 关闭座位
      this.seatsMap.closeSeatHandler({
        x: parseInt(data.x),
        y: parseInt(data.y)
      })
      // 从selectedSeatsData中删除该座位数据
      this.selectedSeatsData.splice(index, 1)
      // 如果selectedSeatsData为空，则显示确认和座位选择按钮，隐藏座位选择按钮
      if (!this.selectedSeatsData.length) {
        this.showRec = true
        this.showSeats = false
      }
    },
    // 初始化节点
    initNode() {
      // 设置maxCanvas节点
      this.el.maxCanvas = this.$refs.maxCanvas
      // 设置maxCanvas的宽度
      this.el.maxCanvas.style = window.innerWidth || window.screen.width
      this.el.maxCanvas.setAttribute('width', window.innerWidth || window.screen.width)
      // 设置maxCanvas的高度
      let height = (window.innerHeight || window.screen.height) - (this.footerHeight + 90)
      this.el.maxCanvas.setAttribute('height', height)
      // 设置maxScreen节点
      this.el.maxScreen = this.$refs.maxScreen
      // 设置sequence节点
      this.el.sequence = this.$refs.sequence
      // 设置seatsOptions中的sequence选项
      this.seatsOptions['sequence'] = {
        el: this.el.sequence,
        style: {
          position: 'absolute',
          top: '0px',
          left: '5px',
          padding: '0 2px',
          backgroundColor: 'rgba(0, 0, 0, .6)',
          color: '#fff',
          fontSize: '12px',
          borderRadius: '100px',
          zIndex: '999',
          marginTop: '80px'
        }
      }
      // 设置seatsOptions中的screen选项
      this.seatsOptions['screen'] = {
        el: this.el.maxScreen
      }
    },
    // 获取座位数据
    getSeatsData() {
      // 初始化seats数组和loveSeat变量
      getSeatList( {
        showid: this.params.showid,
        // mobile:this.$store.state.cinema.mobile,
        // mobile:  window.SITE_CONFIG['mobile'] || this.$store.state.cinema.mobile,
        mobile:this.params.mobile,
        param:this.params.param,

        // mobile:this.params.tel
      }).then(res => {
        console.log(res)
        let seats = []
        this.seats = []
        // 如果返回的座位数据存在
        if(res?.data?.seat_data?.length){
          let loveSeat = 0
          this.seats = res.data.seat_data
          res.data.seat_data.map((item,index)=>{
            let key = 'love_seat_'
            // 如果座位是情侣座，loveSeat加1
            if(item.flag === 1){
              key += loveSeat
            }else if(item.flag === 2){
              key += loveSeat
              loveSeat++
            }
            seats.push({
              y:item.coordy,//座位坐标
              x:item.coordx,
              status: item.status === 1? 0 : 2, //  座位状态【0：可选， 1： 已选， 2： 已售】
              type: [1,2].includes(item.flag) ? 0 : 1, // 座位类型【0：情侣座， 1：非情侣座】
              key: [1,2].includes(item.flag) ? key : '', // 当座位类型为情侣座时，key为必选，且两个情侣座位的key相同
              seatId: item.seatId,
              SeatCode: item.seatId,
              areaId: item.areaId,
              area_id: item.area_id,
              seatNo: item.name,
              price: item.price ? ((item.price - 0)/100).toFixed(2) : '0' // 价格
            })
          })
        }else{
          seats = seatData
        }
        // 如果返回的show_info数据存在
        if(res?.data?.show_info){
          if(res.data.show_info.area_price){
            res.data.show_info.area_price = JSON.parse(res.data.show_info.area_price)
          }
          this.show_info = res.data.show_info
        }
        // 如果返回的film_info数据存在
        if(res?.data?.film_info){
          this.film_info = res.data.film_info
        }
        // 如果seats数组长度存在
        if(seats.length){
          // 设置座位数据并绘制大地图
          this.seatsMap.setSeatData(seats).drawLargeMap()
        }
      }).catch(function (err) {
        console.log(err);
      })
      // 使用$.ajax方法获取座位数据
      // this.seatsMap.$.ajax({
      //     type: 'get',
      //     url: 'js/seats.json',
      //     success: (data) => {
      //         this.seatsMap.setSeatData(JSON.parse(data)).drawLargeMap()
      //     }
      // })
    },
    // 选择座位
    selectCall(data) {
      console.log(data)
      // 显示确认和座位选择按钮，隐藏座位选择按钮
      this.showRec = false
      this.showSeats = true
      // 初始化selected数组
      let selected = this.selectedSeatsData
      // 遍历data数组，根据x和y的值找到对应的座位数据，并添加到selected数组中
      data.forEach(item => {
        for (let i = 0; i < selected.length; i++) {
          if (item.x == selected[i].x && item.y == selected[i].y) {
            this.selectedSeatsData.splice(i, 1)
            return
          }
        }
        // 如果show_info中的area_price数组存在
        // if(this.show_info.area_price.length && this.show_info.area_price.find(ite=>ite.area === item.areaId)){
        //     let obj = this.show_info.area_price.find(ite=>ite.area === item.areaId)
        //     item.price = obj.price.user_price || ''
        // }
        console.log(item)
        this.selectedSeatsData.push(item)
      })
      // 如果selected数组长度为0，则显示确认和座位选择按钮，隐藏座位选择和确认按钮
      if (!this.selectedSeatsData.length) {
        this.showRec = true
        this.showSeats = false
      }
      console.log(this.selectedSeatsData)
    },
    // 确认选座
    confirmSeats(){
      if(!this.selectedSeatsData.length){
        return false
      }
      // 设置obj对象的属性值
      let obj = {
        showId:this.show_info.showId,
        // mobile:this.$store.state.cinema.mobile,
        // mobile:  window.SITE_CONFIG['mobile'] || this.$store.state.cinema.mobile  ,
        mobile:this.params.mobile,
        // mobile:this.params.tel,
        seatIds:this.selectedSeatsData.map(item=>item.seatId).join('|'),
        seatNames: this.selectedSeatsData.map(item=>item.seatNo).join('|')
      }
      // 发送post请求
      lockSeat(obj).then(res => {
        console.log(res)
        if(res.data.applyKey){
          if(this.backUrl){
            window.location.href = this.backUrl + `?toNewCinema=1&orderCode=${res.data.applyKey}&param=${window.SITE_CONFIG['param']}`
          }
          else{
            // window.location.href = `https://moviepay.fudd.com.cn/apitomovie.html?toNewCinema=1&order_number=${res.data.data.applyKey}&env=${that.params.env}&param=${window.SITE_CONFIG['param']}`
            window.location.href = `https://moviepay.fudd.com.cn/apitomovie.html?toNewCinema=1&applyKey=${res.data.data.applyKey}&env=${that.params.env}&param=${window.SITE_CONFIG['param']}`
          }
          // window.location.href = `https://pay.tuweiji.com/apito.html?toNewCinema=1&applyKey=${res.data.applyKey}`
        }else{
          alert(res.data.msg)
        }
      }).catch(e=>{
        console.log(e)
      })
    },
    onClickLeft(){
      this.$router.back()
    }
  },
  created() {

  },
  mounted() {
    this.params.showid = this.$route.query.showid
    this.params.mobile = window.SITE_CONFIG['mobile'] || this.$store.state.cinema.mobile
    // 初始化节点
    this.initNode()
    // 初始化地图
    this.initMap()
  },
  computed: {
    // 回跳地址
    backUrl(){
      return this.$store.state.cinema.backUrl
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
/* 大座位图屏幕 - max-canvas screen css */
#screen {
  position: absolute;
  width: 100%;
  height: 40px;
  margin-top: 15px;
}

#screen > img {
  display: block;
  width: 60%;
  margin: 0 auto;
}

#screen > p {
  display: block;
  width: 90%;
  margin: 0 auto;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 20px;
  font-size: 12px;
  transform: translateX(-50%);
}

/* 大座位图 - max-canvas css */
#container {
  position: relative;
}

#canvas {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 80px;
}

/* 大座位图左边数字标识 css */
.siled {
  margin-top: 40px;
  position: absolute;
  left: 5px;
  padding: 0 2px;
  background-color: #000;
  color: #fff;
  font-size: 12px;
  border-radius: 100px;
  z-index: 999;
}

.seats-option {
  width: 60%;
  padding-top:20px;
  margin: 0 auto;
  font-size:28px;
}

.seats-option > ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.seats-option li {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.seats-option li > img {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}

.seats-option li > span {
  font-size: 30px;
}

#app {
  padding: 10px 0 0;
}

/* 底部业务 - css */
.footer-container {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-bottom: 20px;
  z-index: 9999;
}

.notice {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  padding: 0 15px;
  color: #82848a;
  position: relative;
}

.notice::after {
  content: "";
  width: 93%;
  position: absolute;
  left: 15px;
  bottom: 0;
  border-bottom: 1px solid #f3f4f6;
}

.film-info {
  padding: 10px 15px 0;
}

.name {
  font-size: 15px;
  font-weight: 600;
}

.time {
  padding-top: 4px;
  font-size: 13px;
  color: #82848a;
}

.rec-node {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px;
}

.rec-node ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 20px;
}

.rec-node ul li {
  padding: 5px 10px;
  background-color: #f4f4f4;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 13px;
}

.btn {
  width: 80%;
  margin: 0 auto;
  background-color: #F00;
  text-align: center;
  color: #fff;
  line-height: 80px;
  font-size:30px;
  border-radius: 100px;
}

.selected-node {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px;
  overflow-x: auto;
}

.selected-node ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.selected-node ul li {
  margin-right: 10px;
  background-color: #f4f4f4;
  padding: 6px 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
}

.selected-node ul li span {
  padding-left: 10px;
  font-size: 30px;
  color: #82848a;
}

.seat-name {
  font-size: 30px;
}

.seat-price {
  font-size: 28px;
  color: #F00;
  padding-top: 2px;
}

.selected-node::-webkit-scrollbar {
  display: none;
}
</style>
